import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatAmount, formatEventDate } from "@/lib/format";
import EmptyState from "@/components/EmptyState";
import { Gift, Plus } from "lucide-react";

export default function OrgVouchersListPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/organizer/voucher-batches").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="org-vouchers-list-page">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, gap: 12, flexWrap: "wrap" }}>
        <div>
          <h1 className="z-page-title">Bons d'achat</h1>
          <p className="z-page-sub" style={{ marginBottom: 0 }}>{items.length} lot(s)</p>
        </div>
        <Link to="/org/voucher-create" className="z-btn z-btn-primary" data-testid="new-batch-btn"><Plus size={16} /> Nouveau lot</Link>
      </div>

      {items.length === 0 ? (
        <EmptyState icon={<Gift size={28} />} title="Aucun lot" message="Créez votre premier lot de bons d'achat." testId="vouchers-empty">
          <Link to="/org/voucher-create" className="z-btn z-btn-primary">Créer un lot</Link>
        </EmptyState>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
          {items.map((b) => (
            <Link key={b.id} to={`/org/voucher-batch/${b.id}`} className="z-card" style={{ padding: 16, textDecoration: "none", color: "inherit" }} data-testid={`batch-${b.id}`}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span className="z-badge z-badge-teal">{b.type === "amount" ? "💰 Montant" : "🎁 Articles"}</span>
                {b.status === "pending" && <span className="z-badge">En attente</span>}
              </div>
              <h3 style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700 }}>{b.title}</h3>
              <div style={{ fontSize: 13, color: "var(--z-muted)" }}>
                {b.type === "amount" ? formatAmount(b.amount, b.currency) : `${b.items.length} articles`} × {b.quantity} bons
              </div>
              {b.expires_at && (
                <div style={{ fontSize: 12, color: "var(--z-muted)", marginTop: 4 }}>Expire le {formatEventDate(b.expires_at)}</div>
              )}
              <div style={{ marginTop: 10, fontSize: 13 }}>
                <span style={{ color: "var(--z-teal)", fontWeight: 600 }}>{b.claimed}</span> réclamés ·{" "}
                <span style={{ color: "var(--z-success)", fontWeight: 600 }}>{b.fully_used}</span> épuisés
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
